@if (shouldShowBanner()) {
  <div class="analytics-banner" role="dialog" aria-label="Preferencias de analítica">
    <div class="analytics-banner__content">
      <span class="analytics-banner__text">
        Usamos analítica de uso y diagnóstico para mejorar el portal y detectar incidencias. Puedes configurarlo antes
        de decidir.
      </span>

      <div class="analytics-banner__links">
        <iahoy-link-button
          text="Configurar preferencias"
          variant="inverted"
          [removeSpacing]="true"
          (click)="openPreferences()"
        ></iahoy-link-button>
        <iahoy-link-button
          text="Política de cookies"
          variant="inverted"
          [href]="cookiePolicyUrl"
          [target]="'_blank'"
          [removeSpacing]="true"
        ></iahoy-link-button>
      </div>
    </div>

    <div class="analytics-banner__actions">
      <iahoy-link-button
        text="Rechazar"
        variant="inverted"
        [removeSpacing]="true"
        (click)="rejectAnalytics()"
      ></iahoy-link-button>
      <iahoy-button text="Entendido" variant="accent" (click)="acceptAnalytics()"></iahoy-button>
    </div>
  </div>
}
